//@constants
const actionTypes = require('constants/actionTypes');
const { FIRST_STEP } = require('constants/index');
const { CREDIT_CARD_REVOLVING_PROCESS } = require('constants/flagBasedFeatures');
//@utilities
const { APIPost } = require('utilities/APIRequestHelper');
//@actions
const signaturePatternActions = require('actions/signaturePattern');
const { setTermsAndCondsInfoRevolving } = require('actions/cardRevolvingDocuments');

const requestDecreaseLimitInProgress = () => {
    return {
        type: actionTypes.CARD_MODIFY_LIMIT_DECREASE_REQUEST
    };
};

const requestDecreaseLimitSuccess = (approvedAmount) => {
    return {
        type: actionTypes.CARD_MODIFY_LIMIT_DECREASE_SUCCESS,
        payload: {
            approvedAmount
        }
    };
};

const requestDecreaseLimitFailure = error => {
    return {
        type: actionTypes.CARD_MODIFY_LIMIT_DECREASE_FAILURE,
        payload: {
            error
        }
    };
};

const requestDecreaseLimit = cardId => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const immCard = getState().cards.getIn(['byId', cardId]);
        const immCardModifyLimit = getState().cardModifyLimit;
        const currentLimitCode = immCard.get('currentLimitCode');
        const subtypeProductCode = immCardModifyLimit.getIn(['increaseLimits', 'cardReferenceData', 'subtype']);
        const immStepOne = immCardModifyLimit.getIn(['steps', FIRST_STEP]);
        const contractNumber = immCard.getIn(['contract', 'number']);
        const showIneAndRevolving = getState().flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);

        const params = {
            query: {
                codigoLimiteActual: currentLimitCode,
                codigoSubtipoProducto: subtypeProductCode,
                contrato: {
                    numerodecontrato: contractNumber,
                    producto: immCard.getIn(['contract', 'product'])
                },
                dataToken,
                limiteImporteActual: {
                    divisa: immStepOne.get('currency'),
                    importe: immStepOne.get('currentLimit')
                },
                nuevoLimite: {
                    divisa: immStepOne.get('currency'),
                    importe: immStepOne.get('tentativeLimit')
                },
                pan: immCard.get('number')
            }
        };

        dispatch(requestDecreaseLimitInProgress());
        return APIPost({dispatch, endpoint: 'cardDecreaseLimit', params})
            /*
             * Response is empty at success, so we pass the tentative limit as the new approved amount.
             * We are not handling operationId here as in the card increase limit.
             */
            .then(() => {
                if (showIneAndRevolving) {
                    const termsAndsCondsHiringData = [
                        {
                            standard: immCard.getIn(['product', 'standard']),
                            subType: immCard.getIn(['product', 'subtype']),
                            type: immCard.getIn(['product', 'type'])
                        }
                    ];
                    dispatch(setTermsAndCondsInfoRevolving(immCard.get('standarAlias'), termsAndsCondsHiringData, contractNumber));
                }
                dispatch(requestDecreaseLimitSuccess(immStepOne.get('tentativeLimit')))
            })
            .catch(response => {
                if (!!response.error) {
                    dispatch(requestDecreaseLimitFailure(response));
                } else {
                    throw response;
                }
            });
    };

    new Promise(() => signaturePatternActions.validateAndExecute(dispatch, getState, callback));
};

module.exports = { requestDecreaseLimit };
